import { useMemo } from 'react';
import { Box } from '@mui/material';
import useMuiTableBuilderV2 from 'hooks/useMuiTableBuilderV2';
import { getTableConfig } from './ServiceMetricsTable/tableConfig';
import { useServiceMetricsListItemBuilder } from './ServiceMetricsTable/useServiceMetricsListItemBuilder';
import { ServiceMetricsData, ServiceMetricsCustomRowProps } from './ServiceMetricsTable/types';

const tableConfig = getTableConfig();

type ServiceMetricsTableProps = {
  data: ServiceMetricsData[];
  isLoading: boolean;
  _customRowProps: ServiceMetricsCustomRowProps;
};

const ServiceMetricsTable = ({ data, isLoading, _customRowProps }: ServiceMetricsTableProps) => {
  const listItemsBuilder = useServiceMetricsListItemBuilder();

  const mainList = useMemo(() => {
    const listItems = listItemsBuilder({
      data,
      expandedIds: _customRowProps.expandedIds,
    });

    // Attach row click handlers to data rows
    const augmented = listItems.map((li) => {
      if (li.rowType === 'DATA') {
        return {
          ...li,
          onRowClick: () => {
            const handler = _customRowProps.navigateToIntegrationDetailsPage(
              li.mosaicTeamId,
              _customRowProps.currentService,
              li.targetServiceId,
            );
            handler();
          },
        };
      }
      return li;
    });

    return { listItems: augmented };
  }, [listItemsBuilder, data, _customRowProps]);

  const { TableComponent } = useMuiTableBuilderV2({
    ...tableConfig,
    mainList,
    _customRowProps,
    isLoading,
    tableMaxHeight: '700px',
  });

  return <Box>{TableComponent}</Box>;
};

export default ServiceMetricsTable;
